<ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover">
  <app-card [showHeader]="false" cardClass="user-card" padding="20">
    <div class="flex align-items-center">
      <!-- <div class="flex-shrink-0">
        <img src="assets/images/user/avatar-1.jpg" alt="user-image" class="user-avatar" />
      </div> -->
      <div class="flex-grow-1 user-details">
        <h6>{{user.name}} {{user.surname}}</h6>
        <!-- <small>Administrator</small> -->
      </div>
      <div class="user-setting">
        <a href="javascript:" [matMenuTriggerFor]="menu" class="text-muted">
          <svg class="pc-icon">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-sort-outline"></use>
          </svg>
        </a>
        <mat-menu #menu="matMenu" [overlapTrigger]="false" yPosition="below" xPosition="after">
          <!-- <button mat-menu-item>
            <a href="javascript:" class="text-muted">
              <i class="ti ti-user f-18 m-r-10"></i>
              <span class="mat-body">My Account</span>
            </a>
          </button> -->
          <!-- <button mat-menu-item>
            <a href="javascript:" class="text-muted">
              <i class="ti ti-settings f-18 m-r-10"></i>
              <span class="mat-body">Settings</span>
            </a>
          </button> -->
          <button mat-menu-item (click)="logout()">
            <a href="javascript:" class="text-muted">
              <i class="ti ti-power f-18 m-r-10"></i>
              <span class="mat-body">Logout</span>
            </a>
          </button>
        </mat-menu>
      </div>
    </div>
  </app-card>

  <mat-form-field class="objectSelect">
    <mat-label>Current object</mat-label>
    <mat-select [(ngModel)]="objectId" (selectionChange)="update()">
      <mat-option [value]="object._id" *ngFor="let object of objects">{{object.name}}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="navbar-content">
    <ul class="nav coded-inner-navbar" (click)="fireOutClick()">
      <ng-container *ngFor="let item of menus">
        <app-menu-group-vertical *ngIf="item.type === 'group'" [item]="item"></app-menu-group-vertical>
        <app-menu-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-menu-collapse>
        <app-menu-item *ngIf="item.type === 'item'" [item]="item"></app-menu-item>
      </ng-container>
    </ul>
  </div>
</ng-scrollbar>
